export const login_intro = {
  title: "Sign in",
  title_second_factor: "Second sign-in step",
  link_recovery: "Forgot password?",
  mfa_tab_code: "Email code",
  mfa_tab_totp: "Authenticator app",
  mfa_tab_webauthn: "Security key",
  mfa_tab_passkey: "Passkey",
  mfa_tab_lookup_secret: "Backup codes",
};
